import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { changeAuth } from "../actions/loginAction";
import MessageSnackbar from "../_layout/elements/snackbar";
import pdfImage from "../assets/images/pdf.png";
import { TextField, Modal, Box, FormControl, MenuItem, Select, FormControlLabel, InputLabel, DialogActions, IconButton, Switch, OutlinedInput, InputAdornment } from "@mui/material";
import { styled } from "@mui/material/styles";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import * as mammoth from "mammoth";
import html2canvas from "html2canvas";
import * as XLSX from "xlsx";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import SendOutlinedIcon from "@mui/icons-material/SendOutlined";
import pdffile from "../assets/images/pdf-file.svg";
import docicon from "../assets/images/docx.jpg";
import excelicon from "../assets/images/excel.jpg";
import websiteIcon from "../assets/images/type_website.png";
import CircularProgressloader from "./loader/CircularProgress";
import host from "../host";
import DeleteIcon from "@mui/icons-material/Delete";
import filetype from "../assets/images/type_file.png";
import filewebsite from "../assets/images/type_website.png";
import filePostgres from "../assets/images/type_Postgres.png";
import { pdfjs } from "react-pdf";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

export default function UploadDoc(props) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [progress, setProgress] = React.useState(0);

  React.useEffect(() => {
    const timer = setInterval(() => {
      setProgress((oldProgress) => {
        if (oldProgress === 100) {
          return 0;
        }
        const diff = Math.random() * 10;
        return Math.min(oldProgress + diff, 100);
      });
    }, 500);
    return () => {
      clearInterval(timer);
    };
  }, []);
  //custom question dropdown select   function start//
  const [selectedOption, setSelectedOption] = useState("option1");
  const handleChangeSelectedOption = (option) => {
    setSelectedOption(option);
  };
  //custom question dropdown select   function end//
  const [snackbar, setSnackbar] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("success");
  const onClose = () => {
    setSnackbar(false);
  };

  //file upload functionality begins
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [fileLoading, setFileLoading] = useState(false);
  const [url, setUrl] = useState("");
  const fileInputRef = useRef(null);
  const MAX_FILE_SIZE = 32 * 1024 * 1024; // size limit for file in future

  //handle db upload
  const [dbUser, setDbUser] = useState("");
  const [dbPassword, setDbPassword] = useState("");
  const [dbHost, setDbHost] = useState("");
  const [dbPort, setDbPort] = useState("");
  const [dbName, setDbName] = useState("");
  const [showPassword, setShowPassword] = React.useState(false);
  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleFileChange = (event) => {
    if (props?.selectedBrain?.rights === "Viewer") {
      setSeverity("warning");
      setMessage("You can only view this folder and do not have access to edit the folder");
      setSnackbar(true);
      return;
    }
    const files = event.target.files;
    const newSelectedFiles = Array.from(files).filter((file) => {
      if (file.size > MAX_FILE_SIZE) {
        setSeverity("error");
        setMessage("Please upload file with less than 32MB");
        setSnackbar(true);
        return false;
      }
      return true;
    });
    setSelectedFiles((prevSelectedFiles) => [...prevSelectedFiles, ...newSelectedFiles]);
  };

  const handleFileDrop = (e) => {
    e.preventDefault();
    if (props.selectedBrain.rights === "Viewer") {
      setSeverity("warning");
      setMessage("You can only view this folder and do not have access to edit the folder");
      setSnackbar(true);
      return;
    }
    const files = e.dataTransfer.files;
    const newSelectedFiles = Array.from(files).filter((file) => {
      if (file.size > MAX_FILE_SIZE) {
        setSeverity("error");
        setMessage("Please upload file with less than 32MB");
        setSnackbar(true);
        return false;
      }
      return true;
    });
    setSelectedFiles((prevSelectedFiles) => [...prevSelectedFiles, ...newSelectedFiles]);
  };

  const handleDrag = (e) => {
    e.preventDefault();
  };

  const handleDeleteFile = (fileToDelete) => {
    setSelectedFiles(selectedFiles.filter((file) => file !== fileToDelete));
  };

  //document icon display logic start
  const getIcon = (fileName, doc_type) => {
    if (doc_type === "url") {
      return websiteIcon;
    } else if (doc_type === null) {
      const fileParts = fileName?.split(".");
      const fileExtension = fileParts[fileParts?.length - 1];
      if (fileExtension === "pdf") {
        return pdffile;
      } else if (fileExtension === "docx") {
        return docicon;
      } else if (fileExtension === "xlsx") {
        return excelicon;
      } else {
        return pdffile;
      }
    } else {
      return pdffile;
    }
  };
  //document icon display logic end

  function dataURItoBlob(dataURI) {
    // Convert base64/URLEncoded data component to raw binary data held in a string
    var byteString;
    if (dataURI.split(",")[0].indexOf("base64") >= 0) byteString = atob(dataURI.split(",")[1]);
    else byteString = unescape(dataURI.split(",")[1]);

    // Separate out the mime component
    var mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];

    // Write the bytes of the string to a typed array
    var ia = new Uint8Array(byteString.length);
    for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }

    return new Blob([ia], { type: mimeString });
  }

  const [ocr, setOcr] = useState(false);

  const handleUpload = () => {
    if (!selectedFiles[0]) {
      setSeverity("error");
      setMessage("Select a file please");
      setSnackbar(true);
      return;
    }
    setFileLoading(true);
    const formData = new FormData();
    formData.append("file", selectedFiles[0]);

    const reader = new FileReader();
    reader.onload = function (event) {
      if (selectedFiles[0].type === "application/pdf") {
        const pdfData = new Uint8Array(event.target.result);
        pdfjs.getDocument({ data: pdfData }).promise.then(function (pdf) {
          pdf.getPage(1).then(function (page) {
            const viewport = page.getViewport({ scale: 1 });
            const canvas = document.createElement("canvas");
            const context = canvas.getContext("2d");
            canvas.height = viewport.height;
            canvas.width = viewport.width;

            const renderContext = {
              canvasContext: context,
              viewport: viewport,
            };
            page.render(renderContext).promise.then(function () {
              canvas.toBlob(function (blob) {
                const thumbnailFile = new File([blob], "thumbnail.png", { type: blob.type });
                formData.append("thumbnail", thumbnailFile); // Append the thumbnail image

                return fetch(host.chaturl + `/brain/upload/${props.selectedBrain ? props.selectedBrain.id : props.brainList[0].id}`, {
                  method: "POST",
                  headers: {
                    Authorization: "Bearer " + localStorage.getItem("token"),
                  },
                  body: formData,
                })
                  .then((res) => {
                    if (res.ok) {
                      return res.json();
                    } else if (res.status === 403) {
                      return res.json().then((data) => {
                        if (data.detail === "You don't have the required role(s) for this brain") {
                          setFileLoading(false);
                          setSeverity("warning");
                          setMessage("You can only view this folder and do not have access to edit the folder.");
                          setSnackbar(true);
                        } else {
                          dispatch(changeAuth(false, null));
                          navigate("/logout");
                        }
                      });
                    } else {
                      setFileLoading(false);
                      setSeverity("error");
                      setMessage("Something went wrong");
                      setSnackbar(true);
                    }
                  })
                  .then((data) => {
                    if (data.message === "Document uploaded successfully") {
                      setFileLoading(false);
                      setSeverity("success");
                      setMessage("Knowledge Uploaded Successfully");
                      setSnackbar(true);
                      props.handleCloseuploaddoc();
                      setSelectedFiles([]);
                      props.getKnowledge();
                    } else {
                      setFileLoading(false);
                      setSeverity("error");
                      setMessage(data.message);
                      setSnackbar(true);
                    }
                  })
                  .catch((error) => {
                    console.error("Error uploading file:", error);
                    setFileLoading(false);
                  });
              });
            });
          });
        });
      } else if (selectedFiles[0].type === "application/msword" || selectedFiles[0].type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document") {
        const reader = new FileReader();
        reader.onload = function (event) {
          mammoth
            .convertToHtml({ arrayBuffer: event.target.result })
            .then(function (result) {
              const html = result.value; // The generated HTML
              const messages = result.messages; // Any messages, such as warnings during conversion

              // Create a new off-screen div to hold the HTML
              const div1 = document.createElement("div");
              // div1.style.visibility = 'hidden';
              div1.innerHTML = html;

              // Append the div to the body
              document.body.appendChild(div1);

              // Use html2canvas to take a snapshot of the div
              html2canvas(div1).then(function (canvas) {
                // Get the Data URL from the canvas
                const dataUrl = canvas.toDataURL("image/png");

                // Create a new image file from the Data URL
                fetch(dataUrl)
                  .then((res) => res.blob())
                  .then((blob) => {
                    const thumbnailFile = new File([blob], "thumbnail.png", { type: blob.type });
                    formData.append("thumbnail", thumbnailFile);
                    // Remove the div from the body
                    document.body.removeChild(div1);
                    return fetch(host.chaturl + `/brain/upload/${props.selectedBrain ? props.selectedBrain.id : props.brainList[0].id}`, {
                      method: "POST",
                      headers: {
                        Authorization: "Bearer " + localStorage.getItem("token"),
                      },
                      body: formData,
                    });
                  })
                  .then((res) => {
                    if (res.ok) {
                      return res.json();
                    } else if (res.status === 403) {
                      return res.json().then((data) => {
                        if (data.detail === "You don't have the required role(s) for this brain") {
                          setFileLoading(false);
                          setSeverity("warning");
                          setMessage("You can only view this folder and do not have access to edit the folder.");
                          setSnackbar(true);
                        } else {
                          dispatch(changeAuth(false, null));
                          navigate("/logout");
                        }
                      });
                    } else {
                      setFileLoading(false);
                      setSeverity("error");
                      setMessage("Something went wrong");
                      setSnackbar(true);
                    }
                  })
                  .then((data) => {
                    if (data.message === "Document uploaded successfully") {
                      setFileLoading(false);
                      setSeverity("success");
                      setMessage("Knowledge Uploaded Successfully");
                      setSnackbar(true);
                      props.handleCloseuploaddoc();
                      setSelectedFiles([]);
                      props.getKnowledge();
                    } else {
                      setFileLoading(false);
                      setSeverity("error");
                      setMessage(data.message);
                      setSnackbar(true);
                    }
                  })
                  .catch((error) => {
                    console.error("Error uploading file:", error);
                    setFileLoading(false);
                  });
              });
            })
            .done();
        };
        reader.readAsArrayBuffer(selectedFiles[0]);
      } else if (selectedFiles[0].type === "application/vnd.ms-excel" || selectedFiles[0].type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
        const reader = new FileReader();
        reader.onload = function (event) {
          const workbookData = event.target.result;
          const workbook = XLSX.read(workbookData, { type: "array" });

          // Get the first sheet
          const firstSheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[firstSheetName];

          // Convert the worksheet to HTML
          const html = XLSX.utils.sheet_to_html(worksheet);

          // Create a new off-screen div to hold the HTML
          const div = document.createElement("div");
          //div.style.visibility = 'hidden';
          div.innerHTML = html;

          // Append the div to the body
          document.body.appendChild(div);

          // Use html2canvas to take a snapshot of the div
          html2canvas(div)
            .then((canvas) => {
              // Get the Data URL from the canvas
              const dataUrl = canvas.toDataURL("image/png");

              // Create a blob from the image data
              const blob = dataURItoBlob(dataUrl);

              // Create a File object from the blob
              const thumbnailFile = new File([blob], "thumbnail.png", { type: "image/png" });

              // Append the thumbnail image to formData
              formData.append("thumbnail", thumbnailFile);
              // Remove the div from the body
              document.body.removeChild(div);
              return fetch(host.chaturl + `/brain/upload/${props.selectedBrain ? props.selectedBrain.id : props.brainList[0].id}`, {
                method: "POST",
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("token"),
                },
                body: formData,
              });
              // Continue with your existing logic to send the thumbnail to the server
            })
            .then((res) => {
              if (res.ok) {
                return res.json();
              } else if (res.status === 403) {
                return res.json().then((data) => {
                  if (data.detail === "You don't have the required role(s) for this brain") {
                    setFileLoading(false);
                    setSeverity("warning");
                    setMessage("You can only view this folder and do not have access to edit the folder.");
                    setSnackbar(true);
                  } else {
                    dispatch(changeAuth(false, null));
                    navigate("/logout");
                  }
                });
              } else {
                setFileLoading(false);
                setSeverity("error");
                setMessage("Something went wrong");
                setSnackbar(true);
              }
            })
            .then((data) => {
              if (data.message === "Document uploaded successfully") {
                setFileLoading(false);
                setSeverity("success");
                setMessage("Knowledge Uploaded Successfully");
                setSnackbar(true);
                props.handleCloseuploaddoc();
                setSelectedFiles([]);
                props.getKnowledge();
              } else {
                setFileLoading(false);
                setSeverity("error");
                setMessage(data.message);
                setSnackbar(true);
              }
            })
            .catch((error) => {
              console.error("Error uploading file:", error);
              setFileLoading(false);
            });
        };

        reader.readAsArrayBuffer(selectedFiles[0]);
      } else {
        return fetch(pdfImage)
          .then((response) => response.blob())
          .then((blob) => {
            const thumbnailFile = new File([blob], "thumbnail.png", { type: blob.type });
            formData.append("thumbnail", thumbnailFile); // Append the thumbnail image
            return fetch(host.chaturl + `/brain/upload/${props.selectedBrain ? props.selectedBrain.id : props.brainList[0].id}`, {
              method: "POST",
              headers: {
                Authorization: "Bearer " + localStorage.getItem("token"),
              },
              body: formData,
            });
          })
          .then((res) => {
            if (res.ok) {
              return res.json();
            } else if (res.status === 403) {
              dispatch(changeAuth(false, null));
              navigate("/logout");
            } else {
              setFileLoading(false);
              setSeverity("error");
              setMessage("Something went wrong");
              setSnackbar(true);
            }
          })
          .then((data) => {
            if (data.message === "Document uploaded successfully") {
              setFileLoading(false);
              setSeverity("success");
              setMessage("Knowledge Uploaded Successfully");
              setSnackbar(true);
              props.handleCloseuploaddoc();
              setSelectedFiles([]);
              props.getKnowledge();
            } else {
              setFileLoading(false);
              setSeverity("error");
              setMessage(data.message);
              setSnackbar(true);
            }
          })
          .catch((error) => {
            console.error("Error uploading file:", error);
            setFileLoading(false);
          });
      }
    };
    reader.readAsArrayBuffer(selectedFiles[0]);
  };

  //file upload functionality ends

  // Define the handleWebsiteUrl function
  const handleWebsiteUrl = () => {
    return fetch(host.chaturl + `/brain/upload/url/${props.selectedBrain ? props.selectedBrain.id : props.brainList[0].id}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
      body: JSON.stringify({
        url: url,
      }),
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else if (res.status === 403) {
          dispatch(changeAuth(false, null));
          navigate("/logout");
        } else {
          setFileLoading(false);
          setSeverity("error");
          setMessage("Something went wrong");
          setSnackbar(true);
        }
      })
      .then((data) => {
        setFileLoading(false);
        setSeverity("success");
        setMessage(data.message);
        setSnackbar(true);
        props.handleCloseuploaddoc();
        setSelectedFiles([]);
        setUrl("");
        setDbHost("");
        setDbName("");
        setDbPassword("");
        setDbPort("");
        setDbUser("");
        props.getKnowledge();
      })
      .catch((error) => {
        console.error("Error uploading file:", error);
        setFileLoading(false);
      });
  };

  const IOSSwitch = styled((props) => <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />)(({ theme }) => ({
    width: 38,
    height: 20,
    padding: 0,
    "& .MuiSwitch-switchBase": {
      padding: 0,
      margin: 2,
      transitionDuration: "300ms",
      "&.Mui-checked": {
        transform: "translateX(16px)",
        color: "#fff",
        "& + .MuiSwitch-track": {
          backgroundColor: theme.palette.mode === "dark" ? "#2ECA45" : "#65C466",
          opacity: 1,
          border: 0,
        },
        "&.Mui-disabled + .MuiSwitch-track": {
          opacity: 0.5,
        },
      },
      "&.Mui-focusVisible .MuiSwitch-thumb": {
        color: "#33cf4d",
        border: "6px solid #fff",
      },
      "&.Mui-disabled .MuiSwitch-thumb": {
        color: theme.palette.mode === "light" ? theme.palette.grey[100] : theme.palette.grey[600],
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
      },
    },
    "& .MuiSwitch-thumb": {
      boxSizing: "border-box",
      width: 16,
      height: 16,
    },
    "& .MuiSwitch-track": {
      borderRadius: 26 / 2,
      backgroundColor: theme.palette.mode === "light" ? "#E9E9EA" : "#39393D",
      opacity: 1,
      transition: theme.transitions.create(["background-color"], {
        duration: 500,
      }),
    },
  }));

  return (
    <>
      <MessageSnackbar open={snackbar} autoHideDuration={3000} onClose={onClose} severity={severity} message={message} />
      <Modal open={props.openuploaddoc} onClose={props.handleCloseuploaddoc} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
        <Box className=" commonpopup  modal-common popup-w50 ">
          <div className="card-item__content">
            <div class="card-title">
              <h2>Upload file to start conversation</h2>
            </div>
            <Link className="close" onClick={props.handleCloseuploaddoc}>
              X
            </Link>
          </div>
          <div className="modal-body">
            <div className="popup_scroller">
              <div className="popup-knowledge">
                <div className="whatpdf_wrapper">
                  <div className="setting_upload">
                    <div className="row">
                      <div className="col-md-8 ">
                        <div className="form-group">
                          <FormControl fullWidth size="small">
                            <InputLabel id="demo-simple-select-label">Select Folder</InputLabel>
                            {props?.brainList?.length > 0 && (
                              <Select
                                key={props.selectedBrain ? props.selectedBrain.id : props.brainList[0].id}
                                labelId="demo-select-small-label"
                                id="demo-select-small"
                                value={props.selectedBrain ? props.selectedBrain.id : props.brainList[0].id}
                              >
                                {props.brainList &&
                                  props.brainList?.length > 0 &&
                                  props.brainList
                                    .filter((brain) => brain.brain_type === "text")
                                    .map((brain) => {
                                      return (
                                        <MenuItem
                                          key={brain.id}
                                          value={brain.id}
                                          onClick={() => {
                                            props.setSelectedbrain(brain);
                                          }}
                                        >
                                          {brain.name ? brain.name : "NA"}
                                        </MenuItem>
                                      );
                                    })}
                              </Select>
                            )}
                          </FormControl>
                        </div>
                      </div>
                      {/* <div className="col-md-4">
                        <div className="form-group  ">
                          <FormControlLabel
                            size="small"
                            control={
                              <IOSSwitch
                                size="small"
                                sx={{
                                  m: 1,
                                }}
                                fontSize="small"
                                checked={ocr === true}
                                onChange={() => setOcr(!ocr)}
                              />
                            }
                            label="OCR Enabled"
                          />
                        </div>
                      </div> */}
                      <div className="col-md-12 ">
                        <div className="file_type_upload_wrapper">
                          <div className="file_type_upload_head">
                            <div className="form-group">
                              <label>Upload Type</label>
                            </div>
                            <div className="upload_type_items">
                              <div className="upload_type_items_row">
                                <Link to="#" value="option1" className={`upload_type_cta ${selectedOption === "option1" ? "active" : ""}`} onClick={() => handleChangeSelectedOption("option1")}>
                                  <div className="upload_type_icon">
                                    <img src={filetype} alt="" />
                                  </div>
                                  <div className="upload_type_name">File</div>
                                </Link>

                                <Link to="#" value="option2" className={`upload_type_cta ${selectedOption === "option2" ? "active" : ""}`} onClick={() => handleChangeSelectedOption("option2")}>
                                  <div className="upload_type_icon">
                                    <img src={filewebsite} alt="" />
                                  </div>
                                  <div className="upload_type_name">Website</div>
                                </Link>
                              </div>
                            </div>
                          </div>
                          <div className="file_type_upload_body">
                            {selectedOption === "option1" && (
                              <>
                                <div className="card">
                                  <div className="card-body">
                                    {selectedFiles.length === 0 && (
                                      <div className="csv-upload " onDrop={handleFileDrop} onDragOver={handleDrag} onDragEnter={handleDrag} onDragLeave={handleDrag}>
                                        <div className="upload-pdf">
                                          <label htmlFor="file-upload1">
                                            <input
                                              type="file"
                                              id="file-upload1"
                                              style={{ visibility: "hidden" }}
                                              onChange={handleFileChange}
                                              ref={fileInputRef}
                                              // multiple
                                            />
                                            <div className="svg-circle">
                                              <FileUploadOutlinedIcon />
                                            </div>
                                            <h5> Drag and Drop or Click to Upload a file </h5>
                                            <p>PDF, DOCX, DOC or .XLSX (32MB Max)</p>
                                          </label>
                                        </div>
                                      </div>
                                    )}
                                    {selectedFiles.length > 0 && (
                                      <div className="uploaded-item-wrapper">
                                        {selectedFiles.length > 0 && (
                                          <div className="uploaded-item-body">
                                            <div className="uploaded-item-scroll">
                                              {selectedFiles.map((file, index) => (
                                                <div className="uploaded-item-row" key={index}>
                                                  <div className="file-row">
                                                    {/* Assuming pdffile is your placeholder image */}
                                                    <img src={getIcon(file.name ? file.name : file.doc_type ? file.doc_type : null)} height={25} alt="" />
                                                    <div className="filerowname">{file.name}</div>
                                                  </div>
                                                  {fileLoading ? (
                                                    <div className="file-status">
                                                      <CircularProgressloader />
                                                    </div>
                                                  ) : (
                                                    <div className="delet_file">
                                                      <IconButton aria-label="delete" onClick={() => handleDeleteFile(file)}>
                                                        <DeleteIcon />
                                                      </IconButton>
                                                    </div>
                                                  )}
                                                </div>
                                              ))}
                                            </div>
                                          </div>
                                        )}
                                      </div>
                                    )}
                                    <div className="bottom_submit_btn">
                                      <DialogActions>
                                        <button type="button" className="btn btn-default" onClick={props.handleCloseuploaddoc}>
                                          Close
                                        </button>
                                        <button type="button" className="btn btn-primary" onClick={handleUpload}>
                                          Upload
                                        </button>
                                      </DialogActions>
                                    </div>
                                  </div>
                                </div>
                              </>
                            )}
                            {selectedOption === "option2" && (
                              <div className="card">
                                <div className="card-body">
                                  <div className="upload-other">
                                    <div className="form-group">
                                      <div className="url-search">
                                        <div className="search-url ">
                                          <div className="chat_form_flexbox">
                                            <div className="messageform">
                                              <TextField
                                                id="outlined-multiline-flexible"
                                                placeholder="From URL / https://example.com/file.pdf"
                                                value={url}
                                                onChange={(e) => setUrl(e.target.value)} // Update the state when the input changes
                                              />
                                            </div>
                                            <div className="send_btn">
                                              <Link to="">
                                                <button type="button" className="senderbtn" onClick={handleWebsiteUrl}>
                                                  <SendOutlinedIcon />
                                                </button>
                                              </Link>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Box>
      </Modal>
    </>
  );
}
